import axiosInstance from "./axiosInstance";

export const fetchBranches = (customer_id) => {
    const token = sessionStorage.getItem("token") || localStorage.getItem("token");
    const backendUrl = process.env.REACT_APP_API_URL;
    const params = customer_id ? { customer_id } : {};
    return axiosInstance.get(`${backendUrl}/api/admin/branches`, {
        params,
        headers: { Authorization: `Bearer ${token}` }
    });
};
export const createBranch = (data) => axiosInstance.post("/admin/branches", data);
export const editBranch = (id, data) => axiosInstance.put(`/admin/branches/${id}`, data);
export const deleteBranch = (id) => axiosInstance.delete(`/admin/branches/${id}`);
